module.exports = __webpack_public_path__ + "static/media/after-trial-host.fad95179.gif";